
export const participantTypes = {
    revoked: 'revoked',
    rejected: 'rejected',
    rejectedViewed: 'rejectedViewed',
    owner: 'owner',
    user: 'user',
    invited: 'invited',
    invitedViewed: 'invitedViewed',
    left: 'left',
    deleted: 'deleted',
    firmDeleted: 'firmDeleted'

};
